var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(this.userPushMessagesEnable && this.selectedContext.applicationId)?_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.onClick()}}},[_c('v-icon',{attrs:{"color":_vm.buttonColor}},[_vm._v(_vm._s(this.pushMessages.length ? 'mdi-bell-badge' : 'mdi-bell')+" ")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }